import type { StandardThirdPartyPayload, StandardThirdPartyProvider } from '@shared/models';
import type { ThirdPartyProviderContract } from './types';

export const createStandardOAuthProviderContract = (
  provider: StandardThirdPartyProvider,
): ThirdPartyProviderContract => ({
  provider,
  parse: ({ commonPayload }) =>
    ({
      ...commonPayload,
      provider,
    }) satisfies StandardThirdPartyPayload,
  validate: (payload) => ({
    ready: Boolean(payload.provider && payload.clientId && payload.redirectUrl),
    fallbackRedirectUrl: payload.redirectUrl,
  }),
});
